import React from 'react';
import styled, { css } from 'styled-components';
import {formatCurrency} from "../utils/formatCurrency";
import {Trans} from "../utils/i18n";
import classNames from "classnames";

const Label = styled.label`
    width: 100%;
    height: 100%;
    padding: 10px;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
    transition: background-color .2s,color .2s;
    border-radius: .5rem;
    text-align: center;
    background: #fff;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.15);

    ${props => props.error && css`
        box-shadow: 0 1px 4px 2px rgb(255, 0, 0);
    `}

    ${props => props.checked && css`
        background: #F4F9FF;
        box-shadow: 0 1px 4px 2px rgba(42, 91, 151, 0.7);
    `}
`;

const Input = styled.input`
    display: none;
`;

const LabelText = styled.p`
    margin: 10px 0;
    font-weight: 700;
    text-align: center;

    ${props => props.checked && css`
        color: ${props => props.theme.secondary};
    `}
`;

const LabelDescription = styled.p`
    margin: 5px 0;
    color: ${props => props.theme.gray.dark };
    text-align: center;
    white-space: pre;

    ${props => props.size === 'small' && css`
        font-size: 12px;
    `}
 `;

const LabelPrice = styled.p`
    margin: 5px 0;
    color: ${props => props.theme.gray };
    text-align: center;
    white-space: pre;
    font-size: 12px;
`;

const Price = styled.p`
    margin: 0;
    color: ${props => props.theme.gray };
    text-align: center;
    white-space: pre;
    font-size: 20px;
`;

const Image = styled.img`
    max-width: 100%;
    height: 60px;
    object-fit: contain;
`;

function RadioBig(props) {
    const { disabled, field, input, meta: { touched, error } } = props;
    const id = `${input.name}-${input.value}`.replace(/\s/g, '-').toLowerCase();

    const ecoBadge = typeof field.titel === 'string' ? field.titel.includes('ECO') : null;
    let title = field.titel;
    if(ecoBadge) {
        title = field.titel.replace('ECO', '');
    }

    return (
        <div style={{ height: '100%', ...field.style }}>
            <Input
                disabled={disabled}
                {...input}
                type="radio"
                id={id}
            />
            <Label
                checked={input.checked}
                error={touched && error}
                htmlFor={id}
                style={field.labelStyle}
            >
                {
                    field.image && <Image src={field.image} alt={field.description}/>
                }
                {
                    field.color && <div className={'w-full flex justify-center'}> <div className={'shadow inset w-7 h-7 rounded-full'} style={{ background: field.color }}/></div>
                }
                <LabelText className={classNames({"pr-16": ecoBadge}, field.titleClassName)} checked={input.checked}>{title}</LabelText>
                {
                    field.description && (
                        <LabelDescription size={field.descriptionSize || 'small'} className={field.descriptionClassName}>
                            {field.description}
                        </LabelDescription>
                    )
                }
                {
                    field.price?.priceGross &&
                    <Price>
                        <LabelPrice><Trans i18nKey="common.estimation">Your estimated repair price is</Trans>:</LabelPrice>
                        { formatCurrency(field.price?.priceGross, field.price?.currency) }
                    </Price>
                }
                {
                    ecoBadge && <img className={'absolute right-3 bottom-1 h-5/6 w-auto'} src={'images/icons/eco-friendly.svg'} alt={'Eco friendly'} />
                }
            </Label>
        </div>
    );
}

export default RadioBig;
